export default __webpack_public_path__ + "static/media/vectorLogo.d4d03b29.svg";